import React from "react"
import {
  Label,
  LabelWrapper,
  LabelOptional,
  SelectWrapper,
  FieldError,
  Select,
} from "../styles"
import DownArrow from "../../../images/down-chevron.inline.svg"
import styled from "styled-components"

const InputField = ({
  name,
  label,
  register,
  required,
  valueKey = "value",
  error,
  options,
  ...rest
}) => (
  <LabelWrapper>
    <Label>
      {label} {!required && <LabelOptional>optional</LabelOptional>}
    </Label>
    <SelectWrapper>
      <Select {...register(name, { required })}>
        {options.map((o, i) => {
          const text =
            typeof o.label === "undefined" || typeof o.label !== null
              ? o[valueKey]
              : o.label
          return (
            <option value={o[valueKey]} key={i}>
              {text}
            </option>
          )
        })}
      </Select>
      <DownArrow />
    </SelectWrapper>
    {error && <FieldError>{error}</FieldError>}
  </LabelWrapper>
)

export default InputField
